export default __webpack_public_path__ + "e244488c8cc2f53371535d542a499b57.woff2";